import { render, staticRenderFns } from "./WorkpostPleatingPage.vue?vue&type=template&id=12dac378"
import script from "./WorkpostPleatingPage.vue?vue&type=script&lang=js"
export * from "./WorkpostPleatingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports